import React from 'react';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Standard page layout wrapper with responsive container and spacing
 */
const PageLayout: React.FC<PageLayoutProps> = ({ children, className = '' }) => {
  return (
    <div className={`w-full h-full flex flex-col ${className}`}>
      {children}
    </div>
  );
};

export default PageLayout;